import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getTemplateList, getTemplateUser } from "../../../../services/Templates";
import { toast } from "react-toastify";
import Utils from "../../../../utils";
import CreateFolder from "./CreateFolder";
import EditFolder from "./EditFolder";
import DeleteFolder from "./DeleteFolder";
import MoveFolder from "./MoveFolder";
import RenameEnvelope from "./RenameEnvelope";
import DeleteTemplateEnvelope from "./DeleteTemplateEnvelope";
import MoveEnvelope from "./MoveEnvelope";
import CopyTemplateEnvelope from "./CopyTemplateEnvelope";
import ShareFolder from "./ShareFolder";
import RemoveShareFolder from "./RemoveShareFolder";
import DuplicateTemplate from "./DuplicateTemplate";
import '../../../../assets/template-ui.css';
// import { ReactComponent as FolderIcon } from '../../../../assets/svg/folder.svg';
import { ReactComponent as CalendarIcon } from '../../../../assets/svg/calendar.svg';
import DropdownTriggerIcon from './DropdownTriggerIcon';

// Custom Template Icon SVG
const TemplateIcon = (props) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 24 24"
    fill="none"
    stroke="#a259c6"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect x="4" y="2" width="16" height="20" rx="2" />
    <line x1="8" y1="6" x2="16" y2="6" />
    <line x1="8" y1="10" x2="16" y2="10" />
    <line x1="8" y1="14" x2="12" y2="14" />
  </svg>
);

function Templates() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [viewMode, setViewMode] = useState('grid');
  let buttonList = [
    { id: 1, name: 'My Templates', active: true },
    { id: 2, name: 'Shared with me', active: false },
    { id: 3, name: 'Templates', active: false }
  ];
  const [buttons, setButtons] = useState(buttonList);
  const [isBack, setIsBack] = useState(-1);
  const [templateList, setTemplateList] = useState([]);
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [uuid, setUuid] = useState("");
  const [shareUserList, setShareUserList] = useState([]);

  let currentTemplateObj = {
    tab_id: 1,
    current_tab: "My Templates",
    current_folder: 0,
    is_refresh: false
  };
  const [currentTemplate, setCurrentTemplate] = useState(currentTemplateObj);
  const [isRefresh, setIsRefresh] = useState(false);

  const [folderData, setFolderData] = useState({
    id: '',
    name: ''
  });

  const [removeShareData, setRemoveShareData] = useState({
    id: '',
    type: ''
  });

  // Add state for create dropdown open/close
  const [isCreateDropdownOpen, setIsCreateDropdownOpen] = useState(false);

  // Function to highlight the search term in the text
  const highlightSearchTerm = (text, search) => {
    if (!search || !text) return text;
    const regex = new RegExp(`(${search.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')})`, 'gi');
    const parts = text.split(regex);
    return parts.map((part, index) =>
      regex.test(part) ? (
        <span key={index} className="highlight-search">{part}</span>
      ) : (
        part
      )
    );
  };

  const fetchTemplateList = (obj, useLoader = true) => {
    if (useLoader) {
      setLoading(true);
    }
    getTemplateList(obj)
      .then(response => {
        setTemplateList(response.data.data);
        setBreadcrumbs(response.data.breadcrumbs);
        setIsBack(response.data.back_id);
        setUuid(response.data.uuid);
        if (useLoader) {
          setLoading(false);
        }
      })
      .catch(err => {
        if (useLoader) {
          setLoading(false);
        }
        toast.error(Utils.getErrorMessage(err));
      });
  };

  useEffect(function () {
    getTemplateUser({})
      .then(response => {
        setShareUserList(response.data.data);
      })
      .catch(err => {
        console.error(err);
      });
  }, []);

  useEffect(function () {
    let obj = {
      template: currentTemplate.tab_id,
      folder_id: currentTemplate.current_folder,
      search_term: searchTerm
    };
    fetchTemplateList(obj, true);
  }, [currentTemplate, isRefresh]);

  useEffect(function () {
    let obj = {
      template: currentTemplate.tab_id,
      folder_id: currentTemplate.current_folder,
      search_term: searchTerm
    };
    fetchTemplateList(obj, false);
  }, [searchTerm]);

  const handleTemplateButton = (e, data) => {
    e.preventDefault();
    let button = [...buttonList];
    let currentTem = { ...currentTemplate };
    for (let i = 0; i < button.length; i++) {
      let active = false;
      if (button[i]['id'] === data.id) {
        active = true;
        currentTem.tab_id = data.id;
        currentTem.current_tab = button[i]['name'];
        currentTem.current_folder = 0;
        setSearchTerm("");
      }
      button[i]['active'] = active;
    }
    setButtons(button);
    setCurrentTemplate(currentTem);
  };

  const handleBack = () => {
    if (breadcrumbs.length > 0) {
      // Go to parent folder (second last breadcrumb)
      if (breadcrumbs.length === 1) {
        // Only one breadcrumb, go to root
        let currentTem = { ...currentTemplate };
        currentTem.current_folder = 0;
        setCurrentTemplate(currentTem);
      } else {
        // Go to parent
        let parentId = breadcrumbs[breadcrumbs.length - 2].id;
        let currentTem = { ...currentTemplate };
        currentTem.current_folder = parentId;
        setCurrentTemplate(currentTem);
      }
    } else {
      // Already at root, do nothing or reset
      let currentTem = { ...currentTemplate };
      currentTem.current_folder = 0;
      setCurrentTemplate(currentTem);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const onCreateTemplate = (e) => {
    e.preventDefault();
    navigate('/templates/create/' + uuid);
  };

  const onClickFolder = (e, id) => {
    e.preventDefault();
    let currentTem = { ...currentTemplate };
    currentTem.current_folder = parseInt(id);
    setSearchTerm("");
    setCurrentTemplate(currentTem);
  };

  const onOpenMoveFolder = (e, data) => {
    e.preventDefault();
    let obj = {
      id: data.entity_id,
      name: data.template_name
    };
    setFolderData(obj);
  };

  const onOpenShareFolder = (e, data) => {
    e.preventDefault();
    let obj = {
      id: data.entity_id,
      type: data.entity_type
    };
    setRemoveShareData(obj);
  };

  const onOpenEditFolder = (e, data) => {
    e.preventDefault();
    let obj = {
      id: data.entity_id,
      name: data.template_name
    };
    setFolderData(obj);
  };

  const onOpenDeleteFolder = (e, data) => {
    e.preventDefault();
    let obj = {
      id: data.entity_id,
      name: data.template_name
    };
    setFolderData(obj);
  };

  const onEditTemplate = (e, data) => {
    e.preventDefault();
    navigate('/templates/' + data.template_uuid + '/edit');
  };

  const onCopyTemplate = (e, data) => {
    e.preventDefault();
    let obj = {
      id: data.entity_id,
      name: data.template_name
    };
    setFolderData(obj);
  };

  const onOpenMoveTemplate = (e, data) => {
    e.preventDefault();
    let obj = {
      id: data.entity_id,
      name: data.template_name
    };
    setFolderData(obj);
  };

  const onOpenRenameTemplate = (e, data) => {
    e.preventDefault();
    let obj = {
      id: data.entity_id,
      name: data.template_name
    };
    setFolderData(obj);
  };

  const onOpenDeleteTemplate = (e, data) => {
    e.preventDefault();
    let obj = {
      id: data.entity_id,
      name: data.template_name
    };
    setFolderData(obj);
  };

  const onOpenRemoveShareFolder = (e, data) => {
    setRemoveShareData({
      id: data.entity_id,
      type: data.entity_type
    });
  };

  const onViewTemplate = (e, data) => {
    e.preventDefault();
    navigate('/templates/' + data.template_uuid + '/view');
  };

  return (
    <>
      {loading && (
        <div className="page-loading">
          <img src="/images/loader.gif" alt="loader" />
        </div>
      )}
      <div
        className="section-bg-color"
        style={{ minHeight: "calc(100vh - 54.5px)" }}
      >
        <div className="container template-container" style={{ paddingTop: "10vh" }}>
          <div className="row">
            {/* Sidebar */}
            <aside className="template-ui-sidebar col-12 col-md-3 col-lg-3 col-xl-2 col-xxl-2">
              <div className="template-ui-sidebar-section">
                {buttons.map((item, idx) => {
                  // Choose icon based on button name
                  let iconClass = "bi bi-folder-fill";
                  if (item.name === "My Templates")
                    iconClass = "bi bi-folder-fill";
                  else if (item.name === "Shared with me")
                    iconClass = "bi bi-people-fill";
                  else if (item.name === "Templates") iconClass = "bi bi-stars";
                  return (
                    <button
                      key={idx}
                      className={`template-ui-sidebar-btn sidebar-btn-fixed${item.active ? " active" : ""
                        }`}
                      onClick={(e) => handleTemplateButton(e, item)}
                      type="button"
                    >
                      <span className="template-ui-sidebar-icon">
                        <i className={iconClass} />
                      </span>
                      <span className="template-ui-sidebar-label">
                        {item.name}
                      </span>
                    </button>
                  );
                })}
              </div>
              {/* Team Plan/Upgrade section if needed */}
              {/* <div className="template-ui-sidebar-section" style={{marginTop: 'auto'}}>
                            <div style={{background: '#f3e8ff', borderRadius: '12px', padding: '16px', textAlign: 'center'}}>
                                <div style={{fontWeight: 700, color: '#7c3aed', marginBottom: 6}}>Team Plan</div>
                                <div style={{fontSize: '0.95rem', color: '#7c3aed', marginBottom: 10}}>Upgrade to share unlimited templates with your team</div>
                                <button style={{background: '#a259c6', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 24px', fontWeight: 700, fontSize: '1rem', cursor: 'pointer'}}>
                                    Upgrade
                                </button>
                            </div>
                        </div> */}
            </aside>
            {/* Main Content */}
            <main className="template-ui-content col-12 col-lg-9 col-md-9 col-xl-10 col-xxl-10">
              <div className="template-ui-toolbar-row">
                <div className="template-ui-search-group">
                  <input
                    className="template-ui-search-input"
                    placeholder="Search templates..."
                    value={searchTerm}
                    onChange={handleSearchChange}
                  />
                  {/* <button className="template-ui-filter-btn">Filter</button> */}
                </div>
                <div className="template-ui-toolbar-actions">
                  <div className="template-ui-view-toggle-group">
                    <button
                      className={`template-ui-view-toggle-btn${viewMode === "grid" ? " active" : ""
                        }`}
                      onClick={() => setViewMode("grid")}
                    >
                      <i className="bi bi-grid" />
                    </button>
                    <button
                      className={`template-ui-view-toggle-btn${viewMode === "table" ? " active" : ""
                        }`}
                      onClick={() => setViewMode("table")}
                    >
                      <i className="bi bi-list" />
                    </button>
                  </div>
                  {isBack !== -1 && (
                    <button
                      className="modern-back-btn ms-2 d-flex align-items-center"
                      onClick={handleBack}
                      style={{ gap: 6 }}
                    >
                      <i className="bi bi-arrow-left"></i>
                      <span>Back</span>
                    </button>
                  )}
                  {currentTemplate.tab_id === 1 && (
                    <div className="dropdown">
                      <button
                        className="template-ui-create-btn dropdown-toggle"
                        type="button"
                        id="createDropdown"
                        data-bs-toggle="dropdown"
                        aria-expanded={isCreateDropdownOpen}
                        style={{ minWidth: 120 }}
                        onClick={() => setIsCreateDropdownOpen((open) => !open)}
                        onBlur={() => setIsCreateDropdownOpen(false)}
                      >
                        Create{' '}
                        <i className={`ms-2 bi ${isCreateDropdownOpen ? 'bi-chevron-up' : 'bi-chevron-down'}`}></i>
                      </button>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="createDropdown"
                      >
                        <li>
                          <button
                            className="dropdown-item"
                            type="button"
                            onClick={onCreateTemplate}
                          >
                            Create Template
                          </button>
                        </li>
                        <li>
                          <button
                            className="dropdown-item"
                            type="button"
                            data-bs-toggle="modal"
                            data-bs-target="#createTemplateFolder"
                          >
                            Create Folder
                          </button>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>
              {/* Template List */}
              <div className="template-ui-list-section">
                <div className="teplate-folder">
                  {viewMode === "table" ? (
                    <div className="template-ui-template-list">
                      <div className="template-table-breadcrumbs text-muted  mt-1">
                        {/* Main tab breadcrumb clickable */}
                        <span
                          className="breadcrumb-link"
                          style={{ cursor: "pointer", textDecoration: "underline" }}
                          onClick={e => handleTemplateButton(e, buttons.find(b => b.name === currentTemplate.current_tab) || buttons[0])}
                        >
                          {currentTemplate.current_tab}
                        </span>
                        {breadcrumbs.map((breadcrumb, b) => (
                          <React.Fragment key={b}>
                            <span className="mx-1">/</span>
                            {b === breadcrumbs.length - 1 ? (
                              <span>{breadcrumb.folder_name}</span>
                            ) : (
                              <span
                                className="breadcrumb-link"
                                style={{ cursor: "pointer", textDecoration: "underline" }}
                                onClick={e => onClickFolder(e, breadcrumb.id)}
                              >
                                {breadcrumb.folder_name}
                              </span>
                            )}
                          </React.Fragment>
                        ))}
                      </div>
                      {templateList.map((item, index) => (
                        <div
                          className="template-table-row d-flex align-items-center py-3 px-3 bg-white rounded shadow-sm hover-shadow transition justify-content-between"
                          key={index}
                        >
                          <div className="flex-grow-1 d-flex align-items-center">
                            <div
                              className={`template-table-title fw-semibold ${parseInt(item.entity_type) === 2
                                ? "open_icon"
                                : ""
                                }`}
                              style={{ minWidth: 0 }}
                            >
                              {item.entity_type === 1 ? (
                                <>
                                  <div className="d-flex align-items-center mb-2">
                                    <div className="me-3">
                                      <div className="tamplate-folder-icon">
                                        <i className="bi bi-folder" />
                                      </div>
                                    </div>
                                    <span
                                      onClick={(e) =>
                                        onClickFolder(e, item.entity_id)
                                      }
                                      className="template-table-folder-name text-truncate cur-pointer"
                                      title="Open Folder"
                                     
                                    >
                                      {highlightSearchTerm(
                                        item.template_name,
                                        searchTerm
                                      )}
                                    </span>
                                  </div>
                                  {/* <div
                                    className="template-full-name text-muted "
                                    style={{
                                      maxWidth: 180,
                                      overflowWrap: "break-word",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {item.template_name}
                                  </div> */}
                                </>
                              ) : (
                                <>
                                  <div className="d-flex align-items-center mb-2">
                                    <div className="me-3">
                                      <div className="tamplate-folder-icon">
                                        <TemplateIcon />
                                      </div>
                                    </div>
                                    <span
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent triggering the parent click event
                                        onViewTemplate(e, item);
                                      }}
                                      className="template-table-file-name text-truncate cur-pointer"
                                    >
                                      {highlightSearchTerm(
                                        item.template_name,
                                        searchTerm
                                      )}
                                    </span>
                                  </div>
                                  {/* <div
                                    className="template-full-name text-muted "
                                    style={{
                                      maxWidth: 180,
                                      overflowWrap: "break-word",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {item.template_name}
                                  </div> */}
                                </>
                              )}
                            </div>
                          </div>
                          {currentTemplate.tab_id === 1 && (
                            <>
                              <div className="px-2">
                                {item.is_share === 0 ? (
                                  <span className="badge bg-dark-subtle text-dark-emphasis px-3 py-2">
                                    Not Shared
                                  </span>
                                ) : (
                                  <span className="badge bg-success bg-opacity-10 text-success  px-3 py-2">
                                    Shared
                                  </span>
                                )}
                              </div>
                              <div
                                className="px-2 text-secondary template-date"
                              // style={{ minWidth: 110 }}
                              >
                                <CalendarIcon /> {item.updated_at}
                              </div>
                            </>
                          )}
                          {currentTemplate.tab_id === 2 && (
                            <>
                              <div
                                className="px-2 text-dark fw-medium"
                              // style={{ minWidth: 120 }}
                              >
                                {item.sender_name}
                              </div>
                              <div
                                className="px-2 text-secondary template-date"
                              // style={{ minWidth: 110 }}
                              >
                                <CalendarIcon /> {item.created_at}
                              </div>
                            </>
                          )}
                          {currentTemplate.tab_id === 3 && (
                            <>
                              <div
                                className="px-2 text-secondary template-date"
                                style={{ minWidth: 110 }}
                              >
                                <CalendarIcon /> {item.created_at}
                              </div>
                            </>
                          )}
                          <div className="template-table-actions ms-auto d-flex align-items-center">
                            {currentTemplate.tab_id === 1 && (
                              <div className="dropdown">
                                <span
                                  className="functional_icon_ellipsis_Mytemplate"
                                  id={`dropdownMenuButton-${index}`}
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                  style={{ cursor: "pointer" }}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <DropdownTriggerIcon />
                                </span>
                                <ul
                                  className="dropdown-menu z-3 shadow-sm border-0 rounded-3 py-2"
                                  aria-labelledby={`dropdownMenuButton-${index}`}
                                >
                                  {item.entity_type === 1 ? (
                                    <>
                                      <li
                                        data-bs-toggle="modal"
                                        onClick={(e) =>
                                          onOpenShareFolder(e, item)
                                        }
                                        data-bs-target="#shareFolder"
                                      >
                                        <span className="dropdown-item">
                                          <i className="bi bi-share-fill me-2"></i> Share Folder
                                        </span>
                                      </li>
                                      <li
                                        data-bs-toggle="modal"
                                        onClick={(e) =>
                                          onOpenMoveFolder(e, item)
                                        }
                                        data-bs-target="#moveTemplateFolder"
                                      >
                                        <span className="dropdown-item">
                                         <i className="bi bi-arrows-move me-2"></i> Move Folder
                                        </span>
                                      </li>
                                      <li
                                        data-bs-toggle="modal"
                                        onClick={(e) =>
                                          onOpenEditFolder(e, item)
                                        }
                                        data-bs-target="#editTemplateFolder"
                                      >
                                        <span className="dropdown-item">
                                          <i className="bi bi-type me-2"></i> Rename Folder
                                        </span>
                                      </li>
                                      <li
                                        data-bs-toggle="modal"
                                        onClick={(e) =>
                                          onOpenDeleteFolder(e, item)
                                        }
                                        data-bs-target="#deleteTemplateFolder"
                                      >
                                        <span className="dropdown-item text-danger">
                                          <i className="bi bi-trash me-2"></i> Delete Folder
                                        </span>
                                      </li>
                                    </>
                                  ) : (
                                    <>
                                      <li
                                        onClick={(e) => onEditTemplate(e, item)}
                                      >
                                        <span className="dropdown-item">
                                          <i className="bi bi-pencil me-2"></i> Edit Template
                                        </span>
                                      </li>
                                      <li
                                        data-bs-toggle="modal"
                                        onClick={(e) => onCopyTemplate(e, item)}
                                        data-bs-target="#copyTemplateEnvelope"
                                      >
                                        <span className="dropdown-item">
                                          <i className="bi bi-files me-2"></i> Copy Template
                                        </span>
                                      </li>
                                      <li
                                        data-bs-toggle="modal"
                                        onClick={(e) =>
                                          onOpenShareFolder(e, item)
                                        }
                                        data-bs-target="#shareFolder"
                                      >
                                        <span className="dropdown-item">
                                          <i className="bi bi-share me-2"></i> Share Template
                                        </span>
                                      </li>
                                      <li
                                        data-bs-toggle="modal"
                                        onClick={(e) =>
                                          onOpenMoveTemplate(e, item)
                                        }
                                        data-bs-target="#moveTemplate"
                                      >
                                        <span className="dropdown-item">
                                          <i className="bi bi-arrows-move me-2"></i> Move Template
                                        </span>
                                      </li>
                                      <li
                                        data-bs-toggle="modal"
                                        onClick={(e) =>
                                          onOpenRenameTemplate(e, item)
                                        }
                                        data-bs-target="#renameTemplate"
                                      >
                                        <span className="dropdown-item">
                                          <i className="bi bi-type me-2"></i> Rename Template
                                        </span>
                                      </li>
                                      <li
                                        data-bs-toggle="modal"
                                        onClick={(e) =>
                                          onOpenDeleteTemplate(e, item)
                                        }
                                        data-bs-target="#deleteEnvelopeTemplate"
                                      >
                                        <span className="dropdown-item text-danger">
                                          <i className="bi bi-trash me-2"></i> Delete Template
                                        </span>
                                      </li>
                                    </>
                                  )}
                                </ul>
                              </div>
                            )}
                            {currentTemplate.tab_id === 2 && (
                              <div className="dropdown">
                                <span
                                  className="functional_icon_ellipsis_template"
                                  id={`dropdownMenuButton-${index}`}
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                  onClick={(e) => e.stopPropagation()}
                                  style={{ cursor: "pointer" }}
                                >
                                  <DropdownTriggerIcon />
                                </span>
                                <ul
                                  className="dropdown-menu z-3 shadow-sm border-0 rounded-3 py-2"
                                  aria-labelledby={`dropdownMenuButton-${index}`}
                                >
                                  {item.entity_type === 1 ? (
                                    <li
                                      data-bs-toggle="modal"
                                      onClick={(e) =>
                                        onOpenRemoveShareFolder(e, item)
                                      }
                                      data-bs-target="#removeShareFolder"
                                    >
                                      <span className="dropdown-item text-danger">
                                        <i className="bi bi-x-circle me-2"></i> Remove from Shared with me
                                      </span>
                                    </li>
                                  ) : (
                                    <>
                                      <li
                                        onClick={(e) => onViewTemplate(e, item)}
                                      >
                                        <span className="dropdown-item">
                                          <i className="bi bi-eye me-2"></i> View Template
                                        </span>
                                      </li>
                                      <li
                                        data-bs-toggle="modal"
                                        onClick={(e) => onCopyTemplate(e, item)}
                                        data-bs-target="#duplicateTemplateModal"
                                      >
                                        <span className="dropdown-item">
                                          <i className="bi bi-files me-2"></i> Duplicate template
                                        </span>
                                      </li>
                                      <li
                                        data-bs-toggle="modal"
                                        onClick={(e) =>
                                          onOpenRemoveShareFolder(e, item)
                                        }
                                        data-bs-target="#removeShareFolder"
                                      >
                                        <span className="dropdown-item text-danger">
                                          <i className="bi bi-x-circle me-2"></i> Remove from Shared with me
                                        </span>
                                      </li>
                                    </>
                                  )}
                                </ul>
                              </div>
                            )}
                            {currentTemplate.tab_id === 3 &&
                              (item.entity_type === 1 ? (
                                <div className="dropdown">
                                  <span
                                    className="functional_icon_ellipsis_template"
                                    id={`dropdownMenuButton-${item.entity_id}`}
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <DropdownTriggerIcon />
                                  </span>
                                  <ul
                                    className="dropdown-menu z-3 shadow-sm border-0 rounded-3 py-2"
                                    aria-labelledby={`dropdownMenuButton-${item.entity_id}`}
                                  >
                                    <li
                                      onClick={(e) =>
                                        onClickFolder(e, item.entity_id)
                                      }
                                    >
                                      <span className="dropdown-item">
                                        <i className="bi bi-folder2-open me-2"></i> Open Folder
                                      </span>
                                    </li>
                                  </ul>
                                </div>
                              ) : (
                                <div className="dropdown">
                                  <span
                                    className="functional_icon_ellipsis_template_folder"
                                    id={`dropdownMenuButton-${item.entity_id}`}
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <DropdownTriggerIcon />
                                  </span>
                                  <ul
                                    className="dropdown-menu z-3 shadow-sm border-0 rounded-3 py-2"
                                    aria-labelledby={`dropdownMenuButton-${item.entity_id}`}
                                  >
                                    <li
                                      onClick={(e) => onViewTemplate(e, item)}
                                    >
                                      <span className="dropdown-item">
                                        <i className="bi bi-eye me-2"></i> View Template
                                      </span>
                                    </li>
                                    <li
                                      data-bs-toggle="modal"
                                      onClick={(e) => onCopyTemplate(e, item)}
                                      data-bs-target="#duplicateTemplateModal"
                                    >
                                      <span className="dropdown-item">
                                        <i className="bi bi-files me-2"></i> Copy Template
                                      </span>
                                    </li>
                                  </ul>
                                </div>
                              ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <>
                      <div className="template-table-breadcrumbs text-muted mb-3">
                        {/* Main tab breadcrumb clickable */}
                        <span
                          className="breadcrumb-link"
                          style={{ cursor: "pointer", textDecoration: "underline" }}
                          onClick={e => handleTemplateButton(e, buttons.find(b => b.name === currentTemplate.current_tab) || buttons[0])}
                        >
                          {currentTemplate.current_tab}
                        </span>
                        {breadcrumbs.map((breadcrumb, b) => (
                          <React.Fragment key={b}>
                            <span className="mx-1">/</span>
                            {b === breadcrumbs.length - 1 ? (
                              <span>{breadcrumb.folder_name}</span>
                            ) : (
                              <span
                                className="breadcrumb-link"
                                style={{ cursor: "pointer", textDecoration: "underline" }}
                                onClick={e => onClickFolder(e, breadcrumb.id)}
                              >
                                {breadcrumb.folder_name}
                              </span>
                            )}
                          </React.Fragment>
                        ))}
                      </div>
                      <div className="template-ui-folder-grid">
                        {templateList.map((item, index) => (
                          <div
                            className="template-table-row custom-folder-view cursor-pointer"
                            key={index}
                            onClick={(e) => {
                              if (
                                item.entity_type === 1 &&
                                !e.target.closest(
                                  ".functional_icon_ellipsis_template"
                                ) &&
                                !e.target.closest(
                                  ".functional_icon_ellipsis_template_folder"
                                )
                              ) {
                                onClickFolder(e, item.entity_id);
                              } else if (item.entity_type !== 1) {
                                onViewTemplate(e, item);
                              }
                            }}
                          >
                            <div className="d-flex justify-content-between">
                              <div
                                className={`template-table-title fw-semibold ${parseInt(item.entity_type) === 2
                                  ? "open_icon"
                                  : ""
                                  }`}
                                style={{ minWidth: 0 }}
                              >
                                {item.entity_type === 1 ? (
                                  <>
                                    <div className="me-3">
                                      <div className="tamplate-folder-icon">
                                        <i className="bi bi-folder" />
                                      </div>
                                    </div>
                                    <span
                                      onClick={(e) =>
                                        onClickFolder(e, item.entity_id)
                                      }
                                      className="template-table-folder-name text-truncate cur-pointer"
                                    >
                                      {highlightSearchTerm(
                                        item.template_name,
                                        searchTerm
                                      )}
                                    </span>
                                  </>
                                ) : (
                                  <>
                                    <div className="mb-3">
                                      <div className="tamplate-folder-icon">
                                        <TemplateIcon />
                                      </div>
                                    </div>
                                    <span
                                      onClick={(e) => onViewTemplate(e, item)}
                                      className="template-table-file-name text-truncate cur-pointer"
                                      title="View Template"
                                      
                                    >
                                      {highlightSearchTerm(
                                        item.template_name,
                                        searchTerm
                                      )}
                                    </span>
                                  </>
                                )}
                              </div>
                              <div className="template-table-actions ms-auto d-flex">
                                {currentTemplate.tab_id === 1 && (
                                  <div className="dropdown">
                                    <span
                                      className="functional_icon_ellipsis_template"
                                      id={`dropdownMenuButton-${index}`}
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                      style={{ cursor: "pointer" }}
                                      onClick={e => {
                                        e.stopPropagation();
                                      }}
                                    >
                                      <DropdownTriggerIcon />
                                    </span>
                                    <ul
                                      className="dropdown-menu z-3 shadow-sm border-0 rounded-3 py-2"
                                      aria-labelledby={`dropdownMenuButton-${index}`}
                                    >
                                      {item.entity_type === 1 ? (
                                        <>
                                          <li
                                            data-bs-toggle="modal"
                                            onClick={(e) => { e.stopPropagation(); onOpenShareFolder(e, item) }}
                                            data-bs-target="#shareFolder"
                                          >
                                            <span className="dropdown-item">
                                              <i className="bi bi-share-fill me-2"></i> Share Folder
                                            </span>
                                          </li>
                                          <li
                                            data-bs-toggle="modal"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              onOpenMoveFolder(e, item)
                                            }}
                                            data-bs-target="#moveTemplateFolder"
                                          >
                                            <span className="dropdown-item">
                                              <i className="bi bi-arrows-move me-2"></i> Move Folder
                                            </span>
                                          </li>
                                          <li
                                            data-bs-toggle="modal"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              onOpenEditFolder(e, item)
                                            }}
                                            data-bs-target="#editTemplateFolder"
                                          >
                                            <span className="dropdown-item">
                                              <i className="bi bi-type me-2"></i> Rename Folder
                                            </span>
                                          </li>
                                          <li
                                            data-bs-toggle="modal"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              onOpenDeleteFolder(e, item)
                                            }}
                                            data-bs-target="#deleteTemplateFolder"
                                          >
                                            <span className="dropdown-item text-danger">
                                              <i className="bi bi-trash me-2"></i> Delete Folder
                                            </span>
                                          </li>
                                        </>
                                      ) : (
                                        <>
                                          <li
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              onEditTemplate(e, item)
                                            }}
                                          >
                                            <span className="dropdown-item">
                                              <i className="bi bi-pencil me-2"></i> Edit Template
                                            </span>
                                          </li>
                                          <li
                                            data-bs-toggle="modal"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              onCopyTemplate(e, item)
                                            }}
                                            data-bs-target="#copyTemplateEnvelope"
                                          >
                                            <span className="dropdown-item">
                                              <i className="bi bi-files me-2"></i> Copy Template
                                            </span>
                                          </li>
                                          <li
                                            data-bs-toggle="modal"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              onOpenShareFolder(e, item)
                                            }}
                                            data-bs-target="#shareFolder"
                                          >
                                            <span className="dropdown-item">
                                              <i className="bi bi-share me-2"></i> Share Template
                                            </span>
                                          </li>
                                          <li
                                            data-bs-toggle="modal"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              onOpenMoveTemplate(e, item)
                                            }}
                                            data-bs-target="#moveTemplate"
                                          >
                                            <span className="dropdown-item">
                                              <i className="bi bi-arrows-move me-2"></i> Move Template
                                            </span>
                                          </li>
                                          <li
                                            data-bs-toggle="modal"
                                          
                                             onClick={(e) => {
                                              e.stopPropagation();
                                             onOpenRenameTemplate(e, item)
                                            }}
                                            data-bs-target="#renameTemplate"
                                          >
                                            <span className="dropdown-item">
                                              <i className="bi bi-type me-2"></i> Rename Template
                                            </span>
                                          </li>
                                          <li
                                            data-bs-toggle="modal"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              onOpenDeleteTemplate(e, item)
                                            }}
                                            data-bs-target="#deleteEnvelopeTemplate"
                                          >
                                            <span className="dropdown-item text-danger">
                                              <i className="bi bi-trash me-2"></i> Delete Template
                                            </span>
                                          </li>
                                        </>
                                      )}
                                    </ul>
                                  </div>
                                )}
                                {currentTemplate.tab_id === 2 && (
                                  <div className="dropdown">
                                    <span
                                      className="functional_icon_ellipsis_template"
                                      id={`dropdownMenuButton-${index}`}
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                      style={{ cursor: "pointer" }}
                                        onClick={e => {
                                        e.stopPropagation();
                                      }}
                                    >
                                      <DropdownTriggerIcon />
                                    </span>
                                    <ul
                                      className="dropdown-menu z-3 shadow-sm border-0 rounded-3 py-2"
                                      aria-labelledby={`dropdownMenuButton-${index}`}
                                    >
                                      {item.entity_type === 1 ? (
                                        <li
                                          data-bs-toggle="modal"
                                         
                                           onClick={(e) => {
                                              e.stopPropagation();
                                              onOpenRemoveShareFolder(e, item)
                                            }}
                                          data-bs-target="#removeShareFolder"
                                        >
                                          <span className="dropdown-item text-danger">
                                            <i className="bi bi-x-circle me-2"></i> Remove from Shared with me
                                          </span>
                                        </li>
                                      ) : (
                                        <>
                                          <li
                                            onClick={(e) => {
                                              e.stopPropagation();
                                            onViewTemplate(e, item)
                                            }}
                                            
                                          >
                                            <span className="dropdown-item">
                                              <i className="bi bi-eye me-2"></i> View Template
                                            </span>
                                          </li>
                                          <li
                                            data-bs-toggle="modal"
                                           
                                             onClick={(e) => {
                                              e.stopPropagation();
                                             onCopyTemplate(e, item)
                                            }}
                                            data-bs-target="#duplicateTemplateModal"
                                          >
                                            <span className="dropdown-item">
                                              <i className="bi bi-files me-2"></i> Duplicate template
                                            </span>
                                          </li>
                                          <li
                                            data-bs-toggle="modal"
                                             onClick={(e) => {
                                              e.stopPropagation();
                                           onOpenRemoveShareFolder(e, item)
                                            }}
                                          
                                            data-bs-target="#removeShareFolder"
                                          >
                                            <span className="dropdown-item text-danger">
                                              <i className="bi bi-x-circle me-2"></i> Remove from Shared with me
                                            </span>
                                          </li>
                                        </>
                                      )}
                                    </ul>
                                  </div>
                                )}
                                {currentTemplate.tab_id === 3 &&
                                  (item.entity_type === 1 ? (
                                    <div className="dropdown">
                                      {/* <span
                                    className="functional_icon_ellipsis_templates"
                                    id={`dropdownMenuButton-${item.entity_id}`}
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <DropdownTriggerIcon />
                                  </span> */}
                                      {/* <ul
                                    className="dropdown-menu z-3 shadow-sm border-0 rounded-3 py-2"
                                    aria-labelledby={`dropdownMenuButton-${item.entity_id}`}
                                  >
                                    <li
                                      onClick={(e) =>
                                        onClickFolder(e, item.entity_id)
                                      }
                                    >
                                      <span className="dropdown-item">
                                        Open Folder
                                      </span>
                                    </li>
                                  </ul> */}
                                    </div>
                                  ) : (
                                    <div className="dropdown">
                                      <span
                                        className="functional_icon_ellipsis_template_folder"
                                        id={`dropdownMenuButton-${item.entity_id}`}
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                        style={{ cursor: "pointer" }}
                                          onClick={e => {
                                        e.stopPropagation();
                                      }}
                                      >
                                        <DropdownTriggerIcon />
                                      </span>
                                      <ul
                                        className="dropdown-menu z-3 shadow-sm border-0 rounded-3 py-2"
                                        aria-labelledby={`dropdownMenuButton-${item.entity_id}`}
                                      >
                                        <li
                                         onClick={(e) => {
                                              e.stopPropagation();
                                              onViewTemplate(e, item)
                                            }}
                                          
                                        >
                                          <span className="dropdown-item">
                                            <i className="bi bi-eye me-2"></i> View Template
                                          </span>
                                        </li>
                                        <li
                                          data-bs-toggle="modal"
                                      
                                           onClick={(e) => {
                                              e.stopPropagation();
                                             onCopyTemplate(e, item)
                                            }}
                                          data-bs-target="#duplicateTemplateModal"
                                        >
                                          <span className="dropdown-item">
                                            <i className="bi bi-files me-2"></i> Duplicate template
                                          </span>
                                        </li>
                                      </ul>
                                    </div>
                                  ))}
                              </div>
                            </div>
                            {currentTemplate.tab_id === 1 && (
                              <div className="template-table-actions-footer mt-2 w-100">
                                <div>
                                  {item.is_share === 0 ? (
                                    <span className="badge bg-dark-subtle text-dark-emphasis">
                                      Not Shared
                                    </span>
                                  ) : (
                                    <span className="badge bg-success bg-opacity-10 text-success">
                                      Shared
                                    </span>
                                  )}
                                </div>
                                <div className="text-secondary Mytemplate-date" >
                                  <CalendarIcon />
                                  {item.updated_at}
                                </div>
                              </div>
                            )}
                            {currentTemplate.tab_id === 2 && (
                              <>
                                <div
                                  className="badge bg-dark-subtle text-dark-emphasis my-2 share-badge"
                                  style={{ display: "contents" }}
                                >
                                  {item.sender_name}
                                </div>
                                <div
                                  className="text-secondary Mytemplate-date "
                                  style={{ display: "block" }}

                                >
                                  <CalendarIcon /> {item.created_at}
                                </div>
                              </>
                            )}
                            {currentTemplate.tab_id === 3 && (
                              <>
                                <div
                                  className="text-secondary template-date mt-2"
                                // style={{ minWidth: 110 }}
                                >
                                  <CalendarIcon /> {item.created_at}
                                </div>
                              </>
                            )}

                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </div>
              </div>
              {/* Modals and other components remain unchanged */}
              <CreateFolder
                currentTemplate={currentTemplate}
                isRefresh={isRefresh}
                setIsRefresh={setIsRefresh}
                setLoading={setLoading}
              />
              <EditFolder
                isRefresh={isRefresh}
                setIsRefresh={setIsRefresh}
                setLoading={setLoading}
                folderData={folderData}
                setFolderData={setFolderData}
              />
              <DeleteFolder
                isRefresh={isRefresh}
                setIsRefresh={setIsRefresh}
                setLoading={setLoading}
                folderData={folderData}
                setFolderData={setFolderData}
              />
              <ShareFolder
                shareUserList={shareUserList}
                setLoading={setLoading}
                isRefresh={isRefresh}
                setIsRefresh={setIsRefresh}
                removeShareData={removeShareData}
                setRemoveShareData={setRemoveShareData}
              />
              <MoveFolder
                isRefresh={isRefresh}
                setIsRefresh={setIsRefresh}
                setLoading={setLoading}
                folderData={folderData}
                setFolderData={setFolderData}
              />
              <RenameEnvelope
                isRefresh={isRefresh}
                setIsRefresh={setIsRefresh}
                setLoading={setLoading}
                folderData={folderData}
                setFolderData={setFolderData}
              />
              <DeleteTemplateEnvelope
                isRefresh={isRefresh}
                setIsRefresh={setIsRefresh}
                setLoading={setLoading}
                folderData={folderData}
                setFolderData={setFolderData}
              />
              <MoveEnvelope
                isRefresh={isRefresh}
                setIsRefresh={setIsRefresh}
                setLoading={setLoading}
                folderData={folderData}
                setFolderData={setFolderData}
              />
              <CopyTemplateEnvelope
                isRefresh={isRefresh}
                setIsRefresh={setIsRefresh}
                setLoading={setLoading}
                folderData={folderData}
                setFolderData={setFolderData}
              />
              <DuplicateTemplate
                setLoading={setLoading}
                folderData={folderData}
                setFolderData={setFolderData}
              />
              <RemoveShareFolder
                isRefresh={isRefresh}
                setIsRefresh={setIsRefresh}
                setLoading={setLoading}
                removeShareData={removeShareData}
                setRemoveShareData={setRemoveShareData}
              />
            </main>
          </div>
        </div>
      </div>
    </>
  );
}

export default Templates; 